import { Avatar } from "@mui/material";
import { DemoComunityListObject } from "assets/data/communities";
import { Link } from "react-router-dom";
import { shortUserName } from "utils/helpers/shortUserName";
import { CustomComponentProps } from "utils/types/general.types";

export type UpdatedPostProps = CustomComponentProps & {
    community: DemoComunityListObject;
};

const CreatedCommunity = ({
    community,
    className,
    style
}: UpdatedPostProps) => {
    return (
        <Link
            to={`/communities/view/${community.id}`}
            className={`flex justify-between w-full px-4 py-2 items-center gap-5 hover:shadow-lg hover:text-momeento-50 dark:text-white ${className}`}
            style={style}
        >
            <div className="flex justify-start items-center gap-2">
                <Avatar src={community.img} />
                <div>
                    <h3 className="font-medium">
                        {shortUserName(community.title, 15)}
                    </h3>
                    <p className="text-sm">Members: {community.members}</p>
                </div>
            </div>
            {/* <Link
                to="/users"
                className="w-full px-5 py-2 text-center bg-momeento-50 text-white hover:shadow-xl rounded-full"
            >
                View More
            </Link> */}
        </Link>
    );
};

export default CreatedCommunity;
